var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgAnaliticsBar = function SvgSvgAnaliticsBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.75 22.5a.75.75 0 0 1 0-1.5h.75v-9c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5v9H9V3c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5v18h1.5V7.5c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5V21h.75a.75.75 0 0 1 0 1.5zM21 21V7.5h-3V21zm-7.5 0V3h-3v18zM6 21v-9H3v9z"
  })));
};
export default SvgSvgAnaliticsBar;